import React from 'react'
import styles from './FilePreview.module.scss'

const PauseIcon = () => {
    return (

        <svg className={`${styles.pauseIcon} pause-icon`} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.93 56.8">
            <rect width="19.2" height="56.8" rx="4.21" ry="4.21" />
            <rect x="27.73" width="19.2" height="56.8" rx="4.21" ry="4.21" />
        </svg>
    )
}

export default PauseIcon
